module.exports = __webpack_public_path__ + "static/media/YM65_2.7dee1915.jpg";